export default __webpack_public_path__ + "icon_map_pin_fully_filled.2572c6d4b69931b723fb89b60d91ed7f.svg";